/* eslint-disable @next/next/no-img-element */
import { useGlobalData } from "@/contexts/GlobalData";
import { cn } from "@/lib/utils";
import { Modal, ModalContent, useDisclosure } from "@nextui-org/react";
import { Fragment } from "react";
import DynamicFontSize from "../DynamicFontSize";
import ModalLayout from "../ModalLayout";
import PrimaryButton from "../PrimaryButton";
import DynamicSizeIcon from "../DynamicSizeIcon";
import getIcon from "@/utils/getIcon";
import SecondaryButton from "../SecondaryButton";
type SubPaymentWarningProps = {
  children?: React.ReactNode;
  classNameChildren?: string;
  prefixFromParent?: string;
  handleNext?: () => void;
  conditionOpen?: boolean;
};
function SubPaymentWarning({
  children,
  classNameChildren,
  prefixFromParent = "sub_payment_warning",
  handleNext,
  conditionOpen
}: SubPaymentWarningProps) {
  const {
    isOpen,
    onOpen,
    onOpenChange,
    onClose
  } = useDisclosure();
  const {
    translate,
    getImageFromCMS
  } = useGlobalData();
  return <Fragment>
            <div className={cn("cursor-pointer", classNameChildren)} onClick={conditionOpen ? onOpen : undefined}>
                {children}
            </div>
            <Modal isOpen={isOpen} placement="bottom" onOpenChange={onOpenChange} isDismissable={false} hideCloseButton backdrop="blur" data-sentry-element="Modal" data-sentry-source-file="index.tsx">
                <ModalContent className="rounded-none bg-transparent !mx-0 !my-0 !max-w-[100vw]" data-sentry-element="ModalContent" data-sentry-source-file="index.tsx">
                    <ModalLayout modalKey="830ce6bc-486e-4e55-8474-b1c54670fg15d0edwdfhf" title={translate(prefixFromParent + "_title")} onClose={() => {
          onClose();
        }} data-sentry-element="ModalLayout" data-sentry-source-file="index.tsx">
                        <div className="flex flex-col gap-4 items-center">
                            <DynamicSizeIcon icon={getIcon(prefixFromParent + "_icon")} width={64} height={64} data-sentry-element="DynamicSizeIcon" data-sentry-source-file="index.tsx" />
                            <DynamicFontSize fontSize={14} className="leading-[1.5] text-description" data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">
                                {translate(prefixFromParent + "_content")}
                            </DynamicFontSize>
                            <div className="flex items-center gap-2 w-full">
                                <SecondaryButton className="flex-1 !text-base !leading-[1.2] !font-medium" statusKey={prefixFromParent + "_skip"} status={"normal"} onClick={() => {
                handleNext?.();
                onClose();
              }} data-sentry-element="SecondaryButton" data-sentry-source-file="index.tsx" />
                                <PrimaryButton status={"normal"} statusKey={prefixFromParent + "_close"} className="flex-1" onClick={() => {
                onClose();
              }} data-sentry-element="PrimaryButton" data-sentry-source-file="index.tsx" />
                            </div>
                        </div>
                    </ModalLayout>
                </ModalContent>
            </Modal>
        </Fragment>;
}
export default SubPaymentWarning;